var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"v-app"}},[_c('app-bar'),(_vm.ready)?_c('router-view'):_c('bunt-progress-circular',{attrs:{"size":"huge","page":true}}),_c('snack-bar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }